import {
  SearchableVerticalList,
  SearchableVerticalListDataType,
  SearchableVerticalListDataProps,
} from '@tyrio/ui-library';
import { useEffect, useState } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useDebounce } from '../../hooks/useDebounce';
import routeNames from '../../lib/routeNames';
import { useGetDeliveryMethods } from '../dashboard/delivery-methods/querys/get-delivery-methods';

interface DeliveryMethodsProps {
  switchMenu?: boolean;
  setSwitchMenu: (menu: boolean) => void;
}

const DeliveryMethods = ({
  switchMenu,
  setSwitchMenu,
}: DeliveryMethodsProps) => {
  const history = useHistory();
  const location = useLocation();
  const { path } = useRouteMatch();

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [, setSelected] = useState<Record<string, boolean>>({});

  const debouncedSearch = useDebounce(search, 500);
  const pageSize = 10;

  const handleClick = (
    type: string,
    item?: SearchableVerticalListDataProps
  ) => {
    if (type === 'itemClicked' && item !== undefined) {
      history.push(`/dashboard/company-settings/delivery-method/${item.id}`);
    }
    if (type === 'new') {
      history.push(`/dashboard/company-settings/delivery-method/new`);
    }
  };

  const { deliveryMethodData, isFetching, isError } = useGetDeliveryMethods();

  useEffect(() => {
    if (location.pathname === path) setSelected({});
  }, [debouncedSearch, location.pathname, path]);

  return (
    <SearchableVerticalList
      header="Delivery methods"
      type={SearchableVerticalListDataType.WITHOUT_CHILDREN}
      data={
        deliveryMethodData?.map((item) => ({
          id: item.id,
          name: item.name,
          active: item.isActive,
        })) || []
      }
      path={routeNames.dashboard()}
      isFetching={isFetching}
      isError={isError}
      onSearchChange={setSearch}
      onCreateNew={() => handleClick('new')}
      handleItemClick={(item) => {
        handleClick('itemClicked', item);
      }}
      onChangePage={(page) => setPage(page)}
      count={0}
      pageNumber={page}
      pageSize={pageSize}
      switchMenu={switchMenu}
      setSwitchMenu={setSwitchMenu}
    />
  );
};

export default DeliveryMethods;
